import { StateMachineMap } from 'packages/task-man/service/state-machine/types';

/**
 * Used internally by the Task Management service annotationStateMachine method.
 *
 * This is a Map implementation of a state-machine, used for enforcing expected
 * task annotationState transitions.
 *
 * NOTE: Constants in packages/lib/api/annotations/contract/tasks.ts derive from this
 */
export const stateMachineMap: StateMachineMap = {
  initial: 'ToDo',
  states: {
    ToDo: {
      ASSIGN: 'AnnotationInProgress',
    },
    AnnotationInProgress: {
      SUBMIT: 'QaToDo',
      FLAG: 'Flagged',
      FEEDNEXT: 'AnnotationInReview', // Not currently in use
    },
    // Not currently in use:
    AnnotationInReview: {
      SUBMIT: 'QaToDo',
      FLAG: 'Flagged',
    },
    QaToDo: {
      ASSIGN: 'QaInProgress',
    },
    QaInProgress: {
      SUBMIT: 'QaDone',
      FLAG: 'Flagged',
    },
    QaDone: {
      AUDIT: 'AuditToDo',
      REOPEN: 'Reopened',
      EXPORT: 'QaDone',
    },
    AuditToDo: {
      ASSIGN: 'AuditInProgress',
    },
    AuditInProgress: {
      FLAG: 'Flagged',
      SUBMIT: 'AuditDone',
    },
    AuditDone: {
      EXPORT: 'AuditDone',
    },
    Reopened: {
      ANNOTATE: 'ToDo',
      QA: 'QaToDo',
    },
    Flagged: {
      ASSIGN: 'FlaggedInReview',
    },
    FlaggedInReview: {
      CANCEL: 'Cancelled',
      QA: 'QaToDo',
      ANNOTATE: 'ToDo',
      SUBMIT: 'FlaggedDone',
    },
    FlaggedDone: { EXPORT: 'FlaggedDone' },
    Cancelled: {},
    Error: { ASSIGN: 'ErrorInReview' },
    ErrorInReview: {
      CANCEL: 'Cancelled',
      QA: 'QaToDo',
      ANNOTATE: 'ToDo',
      SUBMIT: 'FlaggedDone', // NOTE: There is no ErrorDone state in the backend
    },
  },
};
